import React, { useState, useEffect, memo } from "react";
import { Outlet, NavLink, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import {  Button,  Layout,  Menu,  Typography,  Popconfirm,  Tooltip,  Grid, Modal} from "antd";
import {  MenuFoldOutlined,  MenuUnfoldOutlined,  TableOutlined,  SettingOutlined,  LogoutOutlined,  UsergroupAddOutlined,} from "@ant-design/icons";
import { useMsal } from "@azure/msal-react";
import logo from "assets/logo.png";
import smalllogo from "assets/smalllogo.png";
import PileImg from "assets/Pile.png";
import SheetPileImg from "assets/SheetPile.png";
import Ibeam from "assets/i-beam.png";
import Dollar from "assets/currency_dollar.png";
import PrecastImg from "assets/Precast.png";
import EuroWallImg from "assets/EuroWall.png";
import UserGuideimg from "assets/Userguide.png";
import UserManual from "pages/Usermanual";
import PileSquareImg from "assets/PileSquare.png";

const { Title, Text } = Typography;
const { Content, Sider } = Layout;
const { useBreakpoint } = Grid;
const iconStyle = {
  width: 20,
  height: 20,
  borderRadius: "50%",
};

const MasterLayout = () => {
  const { instance, accounts } = useMsal();
  const account = accounts?.[0];
  const username = account?.username || "";
  const navigate = useNavigate();
  const location = useLocation();
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const [collapsed, setCollapsed] = useState(true);
  const [userinfo, setUserinfo] = useState([]);
  const [user, setUser] = useState([]);
  const [openGuide, setOpenGuide] = useState(false);

  const handleToggleCollapse = () => setCollapsed((c) => !c);
  const canManageProducts = !["Saler", "SaleManager"].includes(userinfo);
  const canManageCost = ["Admin", "MCost"].includes(userinfo);
  const canAdmin = ["Admin"].includes(userinfo);
  const logout = async () => {
    try {
      const response = await instance.logoutPopup({
        account: account,
        //postLogoutRedirectUri: "/",
        mainWindowRedirectUri: window.location.origin + "/login?from=logout",
      });
      if (response) navigate("/", { replace: true });
    } catch (error) {
      console.log(error);
    }
  };
  // Lấy role theo email (chạy lại khi username thay đổi)
  useEffect(() => {
    let abort = false;
    const run = async () => {
      try {
        if (!username) return
        const [roleRes, typeRes] = await Promise.all([
          axios.post(`${process.env.REACT_APP_BASEURL}/api/getRoleByEmail`, {
            email: username,
          }),
          axios.get(`${process.env.REACT_APP_BASEURL}/api/getAlltypeUser`, {
            params: { email: username },
          }),
        ]);
        if (abort) return;
        setUserinfo(roleRes.data?.[0]?.RoleName);
        setUser(typeRes.data?.[0]);
      } catch (err) {
        console.error("Lỗi khi lấy role:", err);
      }
    };
    run();
    return () => {
      abort = true;
    };
  }, [username]);
  // Tự chọn menu theo URL hiện tại
  const pathname = location.pathname.toLowerCase();
  const selectedKey =
    pathname === "/"
      ? "home"
      : pathname.startsWith("/pile")
        ? "pile"
        : pathname.startsWith("/sheetpile")
          ? "sheetpile"
          : pathname.startsWith("/halocore")
            ? "halocore"
            : pathname.startsWith("/i-beam")
              ? "Ibeam"
              : pathname.startsWith("/precast")
                ? "precast"
                : pathname.startsWith("/eurowall")
                  ? "eurowall"
                  : pathname.startsWith("/squarepile")
                    ? "squarepile"
                    : pathname.startsWith("/managecostmaterial")
                      ? "managecostmaterial"
                      : pathname.startsWith("/admin")
                        ? "admin"
                        : "home";
  const menuItems = [
    {
      key: "home",
      icon: <TableOutlined />,
      label: <NavLink to="/">Bảng Tính Giá</NavLink>,
    },

    {
      key: "UserManual",
      icon: (
        <img
          src={UserGuideimg}
          alt="UserGuide"
          style={{ width: 20, height: 20, borderRadius: "50%" }}
        />
      ),
      label: "Hướng Dẫn Sử Dụng",
      onClick: () => setOpenGuide(true),
    },

    ...(canManageProducts
      ? [
          {
            key: "pile",
            icon: <img src={PileImg} alt="Cọc Ống" style={iconStyle} />,
            label: <NavLink to="/pile">Cọc Ống</NavLink>,
          },
          {
            key: "sheetpile",
            icon: <img src={SheetPileImg} alt="Cừ Ván" style={iconStyle} />,
            label: <NavLink to="/sheetpile">Cừ Ván</NavLink>,
          },
          {
            key: "Ibeam",
            icon: <img src={Ibeam} alt="Dầm I" style={iconStyle} />,
            label: <NavLink to="/I-beam">Dầm I</NavLink>,
          },
          {
            key: "halocore",
            icon: <SettingOutlined />,
            label: <NavLink to="/halocore">Sàn Hollow-Core</NavLink>,
          },
          {
            key: "precast",
            icon: <img src={PrecastImg} alt="Precast" style={iconStyle} />,
            label: <NavLink to="/precast">Cấu Kiện Đúc Sẵn</NavLink>,
          },
          {
            key: "eurowall",
            icon: <img src={EuroWallImg} alt="eurowall" style={iconStyle} />,
            label: <NavLink to="/eurowall">Tấm Tường</NavLink>,
          },
          {
            key: "squarepile",
            icon: <img src={PileSquareImg} alt="squarepile" style={iconStyle} />,
            label: <NavLink to="/squarepile">Cọc Vuông</NavLink>,
          },
        ]
      : []),

    ...(canManageCost
      ? [
          {
            key: "managecostmaterial",
            icon: <img src={Dollar} alt="Money" style={iconStyle} />,
            label: (
              <NavLink to="/managecostmaterial">
                Đơn Giá Vật Tư
              </NavLink>
            ),
          },
        ]
      : []),

    ...(canAdmin
      ? [
          {
            key: "admin",
            icon: <UsergroupAddOutlined />,
            label: <NavLink to="/admin">Admin</NavLink>,
          },
        ]
      : []),
  ];
  return (
    <Layout style={{ background: "#f5f7fa" }}>
      <Sider
        collapsed={collapsed}
        //onCollapse={(value) => setCollapsed(value)}
        collapsedWidth={isMobile ? 0 : 80}
        breakpoint="md"
        width={240}
        style={{
          background: "#fff",
          padding: "16px 8px",
          borderRight: "1px solid #e0e0e0",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "98vh",
        }}
      >
        {/* Logo & Menu */}
        <div>
          <div style={{ textAlign: "center", marginBottom: 24 }}>
            <img
              src={collapsed ? smalllogo : logo}
              alt="Logo"
              style={{
                maxWidth: "80%",
                height: 48,
                objectFit: "contain",
                transition: "all 0.3s",
              }}
            />
          </div>

          <Menu
            mode="inline"
            selectedKeys={[selectedKey]}
            items={menuItems}
            style={{ border: "none" }}
          />
        </div>

        {/* Avatar + Logout + Toggle */}
        <div style={{ padding: "16px 0", textAlign: "center" }}>
          {/* <Tooltip title={account?.username} placement="top">
            <Avatar
              src={null}
              size={collapsed ? 40 : 64}
              icon={<UserOutlined />}
              style={{ marginBottom: collapsed ? 0 : 8, transition: "all 0.3s" }}
            />
          </Tooltip> */}

          {!collapsed && (
            <>
              <Title level={5} style={{ marginBottom: 0 }}>
                {account?.name || "User"}
              </Title>
              <Text type="secondary" style={{ fontSize: 12 }}>
                {account?.username}
              </Text>
            </>
          )}

          <div style={{ marginTop: collapsed ? 12 : 16 }}>
            <Popconfirm
              placement="top"
              title="Xác nhận đăng xuất?"
              okText="Đồng ý"
              cancelText="Huỷ"
              onConfirm={logout}
            >
              <Tooltip title="Đăng xuất" placement="top">
                {collapsed ? (
                  <Button
                    icon={<LogoutOutlined />}
                    type="primary"
                    danger
                    shape="circle"
                    size="large"
                  />
                ) : (
                  <Button
                    icon={<LogoutOutlined />}
                    type="primary"
                    danger
                    size="small"
                    style={{ width: "80%" }}
                  >
                    Đăng xuất
                  </Button>
                )}
              </Tooltip>
            </Popconfirm>
          </div>

          <div style={{ marginTop: 16 }}>
            <Button
              type="default"
              shape="circle"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              size="small"
              onClick={handleToggleCollapse}
            />
          </div>
        </div>
      </Sider>

      {/* Main Content */}
      <Layout style={{ minHeight: "10vh", background: "#f5f7fa" }}>
        <Content
          style={{
            margin: "5px 10px",
            padding: 24,
            height: "98vh",
            background: "#fff",
            borderRadius: 12,
            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
            overflow: "scroll",
          }}
        >
          {/* <Alert
            message="Hệ thống vừa cập nhật giao diện mới"
            description="Giao diện đã được tinh chỉnh về bố cục và vị trí các nút chức năng để nâng cao khả năng hiển thị trên thiết bị màn hình nhỏ. Các chức năng tìm kiếm và lọc dữ liệu cũng sẽ được chuyển trực tiếp lên tiêu đề cột của bảng nhằm tối ưu không gian làm việc và trải nghiệm sử dụng."
            type="info"
            showIcon
            closable = {true}
            style={{ marginBottom: 16 }}
          /> */}
          <Outlet context={{ user }} />
        </Content>
      </Layout>
      <Modal
        title="Hướng Dẫn Sử Dụng"
        open={openGuide}
        onCancel={() => setOpenGuide(false)}
        footer={null}
        width="95vw"
        style={{ top: 20 }}
        maskClosable={false}
      >
        <UserManual />
      </Modal>
    </Layout>
    
  );
};

export default memo(MasterLayout);
